import { render, staticRenderFns } from "./trainingFaq.vue?vue&type=template&id=5bb82066&scoped=true&"
import script from "./trainingFaq.vue?vue&type=script&lang=js&"
export * from "./trainingFaq.vue?vue&type=script&lang=js&"
import style0 from "./trainingFaq.vue?vue&type=style&index=0&id=5bb82066&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb82066",
  null
  
)

export default component.exports